import { render } from "./DCLogo.vue?vue&type=template&id=5e01f416"
const script = {}
script.render = render

export default script